// TypeScript wrapper for downloadFromSDK for React usage
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { storageRef, firebaseConfig } from '@/js/external-js/config/main_config';
import { downloadFromSDK as legacyDownloadFromSDK } from '../../../js/external-js/variableModules/downloadFromSDK.module.js';

export async function downloadEvidence({
  fileName,
  path
}: {
  fileName: string;
  path: string;
}) {
  // Calls legacy SDK with 'download' action
  return legacyDownloadFromSDK(
    firebaseConfig,
    storageRef,
    'download',
    undefined,
    fileName,
    path,
    false,
    {}
  );
}

export async function getEvidenceUrl({
  fileName,
  path
}: {
  fileName: string;
  path: string;
}) {
  // Calls legacy SDK with 'pdf' action for direct link
  return legacyDownloadFromSDK(
    firebaseConfig,
    storageRef,
    'pdf',
    undefined,
    fileName,
    path,
    false,
    {}
  );
}
